module.exports = [{
      plugin: require('/home/steve/fisherman/fisherman-website-generator/output/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
